/** @file viewportCommands: every handler of the viewport binding table and context menus, by command id. */
import { cameraPresets } from './cameraPresets';
import { facingStepsCycle } from './facingStepsCycle';
import { frameView } from './frameView';
import { nudge } from './nudge';
import { poseCommands } from './poseCommands';
import type { ViewportCtx } from './viewportCtx';

/** Camera, facing, isolate, grid, joints and quads handlers (the tools, space, pivot and transport are global bindings). */
function viewHandlers(ctx: ViewportCtx): Record<string, () => void> {
  const st = () => ctx.store.getState();
  return {
    'viewport.frameSelection': () => { frameView(ctx, st().selection.nodes.at(-1)); },
    'viewport.camera.reset': () => { st().setCamera({ yawDeg: 0, pitchDeg: ctx.profile?.camera.pitch ?? 30 }); ctx.camera?.home(); },
    'viewport.facing.fewer': () => { st().setCamera({ facingSteps: facingStepsCycle(st().camera.facingSteps, -1) }); },
    'viewport.facing.more': () => { st().setCamera({ facingSteps: facingStepsCycle(st().camera.facingSteps, 1) }); },
    'viewport.isolate': () => { ctx.isolate = !ctx.isolate; },
    'viewport.grid.toggle': () => { st().setCamera({ grid: !st().camera.grid }); },
    'viewport.joints.toggle': () => { st().setCamera({ joints: !st().camera.joints }); },
    'viewport.quads.toggle': () => { st().setCamera({ quads: !st().camera.quads }); },
  };
}

/** The eight arrow nudges (`viewport.nudge.<dir>[.big]`). */
function nudgeHandlers(ctx: ViewportCtx): Record<string, () => void> {
  const out: Record<string, () => void> = {};
  for (const dir of ['left', 'right', 'up', 'down'] as const) {
    out[`viewport.nudge.${dir}`] = () => { nudge(ctx, dir, false); };
    out[`viewport.nudge.${dir}.big`] = () => { nudge(ctx, dir, true); };
  }
  return out;
}

/** Every viewport command id with its handler; `viewportBindings` binds keys to the same ids. */
export function viewportCommands(ctx: ViewportCtx): Record<string, () => void> {
  return { ...viewHandlers(ctx), ...cameraPresets(ctx), ...nudgeHandlers(ctx), ...poseCommands(ctx) };
}
